"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ApptSummary;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _react2 = require("@xstate/react");
var _xstate = require("xstate");
var _ApptDetails = _interopRequireDefault(require("./ApptDetails"));
var _styles = require("./styles");
const propTypes = {
  awsMapConfig: _propTypes.object,
  config: _propTypes.object.isRequired,
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  track: _propTypes.func.isRequired
};
function ApptSummary(_ref) {
  let {
    awsMapConfig,
    config,
    service,
    track
  } = _ref;
  const [state] = (0, _react2.useService)(service);
  const {
    provider,
    bookedAppt,
    location
  } = state.context;
  return /*#__PURE__*/_react.default.createElement(_styles.ApptSummaryContainer, {
    "data-testid": "ApptSummary"
  }, /*#__PURE__*/_react.default.createElement(_ApptDetails.default, {
    provider: provider,
    appointment: bookedAppt,
    location: location,
    track: track,
    config: config,
    awsMapConfig: awsMapConfig
  }));
}
ApptSummary.propTypes = propTypes;
ApptSummary.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ApptSummary",
  "props": {
    "awsMapConfig": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "config": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};